import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./Home";
import About from "./About";
import Footer from "./Footer";
import React from "react";
import Header from "./Header";
import Contacts from "./Contacts";
import Products from "./Products";
import Services from "./Services";
import Portfolio from "./Portfolio";
import Partners from "./Partners";
import Career from "./Creer";
import Privacy from "./Privacy";
import Cookies from "./Cookies";
import Terms from "./Terms";
import Help from "./Help";
import Faq from "./Faq";
import Useful from "./Useful";
import EU from "./EU";

export default function App() {
    return (
        <BrowserRouter>
            <Header />
                <Routes>
                    <Route index element={<Home />} />
                    <Route path={'/about'} element={<About />} exact />
                    <Route path={'/contacts'} element={<Contacts />} exact />
                    <Route path={'/products'} element={<Products />} exact />
                    <Route path={'/services'} element={<Services />} exact />
                    <Route path={'/portfolio'} element={<Portfolio />} exact />
                    <Route path={'/partners'} element={<Partners />} exact />
                    <Route path={'/career'} element={<Career />} exact />
                    <Route path={'/privacy'} element={<Privacy />} exact />
                    <Route path={'/cookies'} element={<Cookies />} exact />
                    <Route path={'/terms'} element={<Terms />} exact />
                    <Route path={'/help'} element={<Help />} exact />
                    <Route path={'/faq'} element={<Faq />} exact />
                    <Route path={'/useful'} element={<Useful />} exact />
                    <Route path={'/eu'} element={<EU />} exact />
                </Routes>
            <Footer />
        </BrowserRouter>
    );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);